import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ru from './ru.json';

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      ru: {
        translation: ru
      }
    },
    lng: 'ru',
    fallbackLng: 'en',
    debug: true,
    interpolation: {
      escapeValue: false // not needed for react as it escapes by default
    }
    /* react: {
      bindI18n: 'languageChanged',
      bindI18nStore: '',
      transEmptyNodeValue: '',
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'],
      useSuspense: true
    } */
  });

if (localStorage.getItem('debug') === '*') {
  document.addEventListener('keydown', event => {
    if (event.key === 'l') {
      i18n.changeLanguage(i18n.language === 'ru' ? 'en' : 'ru');
    }
  });
}


export default i18n;



// WEBPACK FOOTER //
// ./src/i18n/index.js